import authHeaders from 'helpers/auth-header';
import request from './api';

function getDashboardCurrentAccountReports(vkn) {
  return request({
    url: `/dashboard/cari-reports/identification-number/${vkn}`,
    method: 'GET',
    headers: authHeaders(),
  });
}
function getDashboardMyInvoices(vkn) {
  return request({
    url: `/dashboard/my-invoices/identification-number/${vkn}`,
    method: 'GET',
    headers: authHeaders(),
  });
}
function getDashboardPayeInvoices(vkn) {
  return request({
    url: `/dashboard/paye-invoice/identification-number/${vkn}`,
    method: 'GET',
    headers: authHeaders(),
  });
}
function getDashboardPaymentReports(vkn) {
  return request({
    url: `/dashboard/payment-reports/identification-number/${vkn}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

const dashboard = {
  getDashboardCurrentAccountReports,
  getDashboardMyInvoices,
  getDashboardPayeInvoices,
  getDashboardPaymentReports,
};

export default dashboard;
